import React from 'react';

export const useScreenHeight = (): number => {
  const [screenHeight, setScreenHeight] = React.useState<number>(0);

  React.useLayoutEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenHeight;
};
